import ShowSnackbar from './show-snackbar'

export default class ShowErrorSnackbar extends ShowSnackbar {
  constructor(message: string, timeout = 6000, showClose = true) {
    super(message, timeout, showClose, 'error', 'error')
  }
}
